import { createAction } from 'redux-actions';
import Types from './types';

export const instanceRequest = createAction(Types.INSTANCE_REQUEST);
export const instanceFulfilled = createAction(Types.INSTANCE_FULFILLED);
export const instanceRejected = createAction(Types.INSTANCE_REJECTED);

export const instancePluginSet = createAction(Types.INSTANCE_PLUGIN_SET);
